export default __webpack_public_path__ + "static/media/talk-about-it.dd9bad05.svg";